import {VismaUpsellProduct} from 'common/types/store/threeSixtyTypes';

export interface CommissionCalculation {
    productsCommission: number;
    subscriptionsCommission: number;
    totalCommission: number;
    formattedProductsCommission: string;
    formattedSubscriptionsCommission: string;
    formattedTotalCommission: string;
}

export const useCalculateUpsellCommission = (
	upsellProducts: VismaUpsellProduct[] | null = null,
	upsellSubscriptions: VismaUpsellProduct[] | null = null
): CommissionCalculation => {
	const productsCommissionOre = upsellProducts?.reduce((total, product) => {
		// Check if the product is "Safe Zone" or "Safe Zone+"
		if (product.id === 3 || product.id === 6) {
			const safeZoneCommission = upsellProducts.find(p => p.id === 3)?.commission || 0;
			const safeZonePlusCommission = upsellProducts.find(p => p.id === 6)?.commission || 0;
			const highestCommission = Math.max(safeZoneCommission, safeZonePlusCommission);

			return total + (product.id === 3 ? 0 : highestCommission);
		}

		return total + (product.commission || 0);
	}, 0) || 0;

	// if subscriptionsCommissionOre can be plural sum, use the code below

	// const subscriptionsCommissionOre = upsellSubscriptions?.reduce((total, subscription) => {
	// 	return total + (subscription.commission || 0);
	// }, 0) || 0;

	// Replace the above code with the following to get the highest commission among subscriptions
	const subscriptionsCommissionOre =
    upsellSubscriptions && upsellSubscriptions.length > 0
    	? Math.max(...upsellSubscriptions.map(sub => sub.commission || 0))
    	: 0;

	const productsCommission = productsCommissionOre / 100;
	const subscriptionsCommission = subscriptionsCommissionOre / 100;
	const totalCommission = productsCommission + subscriptionsCommission;

	const formattedProductsCommission = `${productsCommission.toFixed(2)},-`;
	const formattedSubscriptionsCommission = `${subscriptionsCommission.toFixed(2)},-`;
	const formattedTotalCommission = `${totalCommission.toFixed(2)},-`;

	return {
		productsCommission,
		subscriptionsCommission,
		totalCommission,
		formattedProductsCommission,
		formattedSubscriptionsCommission,
		formattedTotalCommission,
	};
};